import * as React from 'react';
import moment from 'moment';
import b_ from 'b_';

import './index.scss';

interface Props {
  title: string;
  children: string | moment.Moment;
}

const b = b_.with('order-card-status-tooltip-tr');

export const Row: React.FC<Props> = ({ title, children: date }) => (
  <tr className={b()}>
    <td>{title}</td>
    <td>{moment(date).format('DD.MM.YY')}</td>
    <td>{moment(date).format('HH:mm')}</td>
  </tr>
);
